<template>
  <div class="mt-15 mb-5 mx-15 d-flex justify-end align-center">
    <v-btn icon :disabled="currentPage == 1" @click="currentPage--"><v-icon color="grey">mdi-arrow-left</v-icon></v-btn>
    <v-text-field v-model="currentPage" solo dense hide-details type="number" class="shrink mx-2 centered-input" style="width: 40px">}</v-text-field>
    <span class="mx-2">of</span>
    <span class="mx-2">{{ totalPage }}</span>
    <v-btn icon :disabled="currentPage == totalPage" @click="currentPage++"><v-icon color="grey">mdi-arrow-right</v-icon></v-btn>
  </div>
</template>

<script>
export default {
  props: {
    list: { type: Array, require: true },
    value: { type: Array, required: true }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  created() {
    this.listToDisplay()
  },
  computed: {
    totalPage() {
      return Math.ceil(this.list.length / 10) || 1
    }
  },
  watch: {
    currentPage() {
      this.listToDisplay()
    }
  },
  methods: {
    listToDisplay() {
      this.$emit('input', this.list.slice((this.currentPage - 1) * 10, this.currentPage * 10))
    }
  }
}
</script>

<style lang="scss">
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
</style>
